// extracted by mini-css-extract-plugin
module.exports = {"componentsPaymentMethodSelector":"styles_componentsPaymentMethodSelector__35Q7O","selected":"styles_selected__2erYV","chooseIcon":"styles_chooseIcon__Rls0V"};